import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const ALL_EVENTS_REQUEST = 'ALL_EVENTS_REQUEST';
export const ALL_EVENTS_SUCCESS = 'ALL_EVENTS_SUCCESS';
export const ALL_EVENTS_FAILURE = 'ALL_EVENTS_FAILURE';

export const EVENTS_REQUEST = 'EVENTS_REQUEST';
export const EVENTS_SUCCESS = 'EVENTS_SUCCESS';
export const EVENTS_FAILURE = 'EVENTS_FAILURE';

export const EVENT_REQUEST = 'EVENT_REQUEST';
export const EVENT_SUCCESS = 'EVENT_SUCCESS';
export const EVENT_FAILURE = 'EVENT_FAILURE';

export const EVENT_UPDATE_REQUEST = 'EVENT_UPDATE_REQUEST';
export const EVENT_UPDATE_SUCCESS = 'EVENT_UPDATE_SUCCESS';
export const EVENT_UPDATE_FAILURE = 'EVENT_UPDATE_FAILURE';

export function requestAllEvents(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/events/search?${query}`,
      method: 'GET',
      types: ["ALL_EVENTS_REQUEST", "ALL_EVENTS_SUCCESS", "ALL_EVENTS_FAILURE"]
    },
  };
}

export function requestEvents(employerCodeNumber, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/client-events/${employerCodeNumber}?${query}`,
      method: 'GET',
      types: ["EVENTS_REQUEST", "EVENTS_SUCCESS", "EVENTS_FAILURE"]
    },
  };
}

export function requestEvent(meetingId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/event-manager/${meetingId}?${query}`,
      method: 'GET',
      types: ["EVENT_REQUEST", "EVENT_SUCCESS", "EVENT_FAILURE"]
    }
  }
}

export function updateEvent(event, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/event-manager?${query}`,
      method: 'POST',
      body: JSON.stringify(event),
      types: ["EVENT_UPDATE_REQUEST", "EVENT_UPDATE_SUCCESS", "EVENT_UPDATE_FAILURE"]
    }
  }
}

export function deleteEvent(meetingId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/event-manager/delete/${meetingId}?${query}`,
      method: 'PUT',
      body: JSON.stringify(meetingId),
      types: ["EVENT_DELETE_REQUEST", "EVENT_DELETE_SUCCESS", "EVENT_DELETE_FAILURE"]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/event-manager/EventManagerActions.js